import httpClient from './httpClient';

const BASE = '/api/pagos-empresa';

const pagoEmpresaService = {

  /**
   * Registrar un pago empresarial que cubre múltiples matrículas.
   * @param {Object} data
   * @param {number}   data.empresa_id
   * @param {number[]} data.matricula_ids
   * @param {number}   data.monto_total
   * @param {number}   data.metodo_id
   * @param {string}   [data.referencia_externa]
   * @param {string}   [data.observaciones]
   */
  crear(data) {
    return httpClient.post(BASE, data);
  },

  /**
   * Listar pagos empresariales.
   * @param {number|null} empresa_id  Filtrar por empresa (opcional)
   */
  listar(empresa_id = null) {
    const qs = empresa_id ? `?empresa_id=${empresa_id}` : '';
    return httpClient.get(`${BASE}${qs}`);
  },

  /**
   * Obtener detalle de un pago empresarial (incluye pagos individuales y saldo_favor).
   * @param {number} id
   */
  obtenerPorId(id) {
    return httpClient.get(`${BASE}/${id}`);
  },

  obtenerComprobante(id) {
    return httpClient.get(`${BASE}/${id}/comprobante`);
  },

  /**
   * Aplicar saldo a favor a nuevas matrículas (ej: nivel 2 recién creadas).
   * @param {number}   id            ID del pago empresarial
   * @param {number[]} matricula_ids Matrículas a cubrir con el crédito
   */
  aplicarCredito(id, matricula_ids) {
    return httpClient.post(`${BASE}/${id}/aplicar`, { matricula_ids });
  },

  confirmar(id, monto_total) {
    return httpClient.post(`${BASE}/${id}/confirmar`, { monto_total });
  },
};

export const obtenerSiguienteReferencia = (prefijo) =>
  httpClient.get(`/api/pagos/siguiente-referencia?prefijo=${prefijo || "PAGO"}`);

export default pagoEmpresaService;
